import React from "react";
import { CheckIcon, GiftIcon } from "lucide-react";
import { bonuses } from "../data/bonuses";
import { SectionCTA } from "./SectionCTA";
export function BonusesSection() {
  return <section className="bg-canvas py-16 md:px-4 md:py-24" data-id="element-68" data-mp="vsmn8pfmiyd6">
      <div className="mx-auto max-w-5xl" data-id="element-69" data-mp="vu7h0cu46d9z">
        <div className="px-4 text-center md:px-0" data-id="element-70" data-mp="qt9zm2gxhn9j">
          <p className="text-sm font-bold uppercase tracking-wider text-brand" data-id="element-71" data-mp="qsi40rnbzpj9">And that's not all…</p>
          <h2 className="mt-3 font-serif text-[32px] font-extrabold leading-tight text-ink md:text-5xl" data-id="element-72" data-mp="14rrldun9wpot">
            5 exclusive <em className="text-brand" data-id="element-73" data-mp="zsn8asx8a7t7">bonuses</em>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-muted" data-id="element-74" data-mp="1eiuk4psqcskx">When you get the Ortho Case Command Center™ today, you'll also receive:</p>
        </div>

        <div className="mt-10 space-y-6 md:space-y-8" data-id="element-75" data-mp="1njsmz4rfmu1x">
          {bonuses.map((b, i) => <article key={b.number} className="overflow-hidden bg-white shadow-sm ring-1 ring-navy-900/10 md:grid md:grid-cols-2 md:items-center md:rounded-3xl" data-id="element-76" data-mp="1jiqmylpoydyw" data-mpi={i}>
              <div className={`bg-white ${i % 2 === 1 ? "md:order-2" : ""}`} data-id="element-77" data-mp="3trnm9r6ls0e2">
                <img src={b.image} alt={`Bonus #${b.number}: ${b.title} mockup`} className="block w-full" loading="lazy" data-id="element-78" data-mp="3ttqg6mavmdo2" />
              </div>
              <div className="px-5 pb-7 pt-2 md:p-8" data-id="element-79" data-mp="7lqlus0v77aq">
                <div className="flex flex-wrap items-center gap-2" data-id="element-80" data-mp="7iclfpbrh85x">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-navy-900 px-3 py-1 text-xs font-extrabold uppercase tracking-wider text-white" data-id="element-81" data-mp="cja9ujnd6yfv">
                    <GiftIcon className="h-3.5 w-3.5 text-brand-cyan" aria-hidden="true" data-id="element-82" data-mp="lbu12z1bu0qo" />
                    Bonus #{b.number}
                  </span>
                  <span className="text-sm font-bold text-muted" data-id="element-83" data-mp="qdaz8msff93k">
                    Value: <s data-id="element-84" data-mp="vbuoox68b30o">{b.value}</s> <span className="ml-1 rounded-md bg-cta px-2 py-0.5 text-white" data-id="element-85" data-mp="vc4dihfjf44s">FREE</span>
                  </span>
                </div>
                <h3 className="mt-3 font-serif text-[26px] font-extrabold leading-tight text-ink md:text-3xl" data-id="element-86" data-mp="akpgedwoevfl">{b.title}</h3>
                <p className="mt-3 text-[16px] leading-relaxed text-muted" data-id="element-87" data-mp="5n73kcfjfw2b">{b.description}</p>
                {b.items.length > 0 && <ul className="mt-4 grid grid-cols-2 gap-x-3 gap-y-2" data-id="element-88" data-mp="kd4x77w8ldyw">
                    {b.items.map(item => <li key={item} className="flex items-start gap-2 text-[14px] font-medium text-ink" data-id="element-89" data-mp="tbqb2pqrk4tc">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-90" data-mp="ocvvdwo3ewdg" />
                        {item}
                      </li>)}
                  </ul>}
              </div>
            </article>)}
        </div>

        <div className="px-4 md:px-0" data-id="element-91" data-mp="y8ytmrftqav4">
          <SectionCTA label="I want the 5 bonuses for free" data-id="element-92" data-mp="352asy0vk05bz" />
        </div>
      </div>
    </section>;
}